import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  CircleStackIcon,
  ClockIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/solid'
import Workspace from './Workspace'
import { BrandScrapersTable } from './BrandScrapersTable'
import AppShell from '../../../../Components/AppShell'
import PageHeader from '../../../../Components/PageHeader'

const WebScrapers = () => {
  const [view, setView] = useState('workspace')

  return (
    <AppShell>
      <PageHeader
        kicker="Listings"
        title="Web Scrapers"
        subtitle="Build scrape requests and maintain the active scraper inventory."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Listings', to: '/listings-tools' },
          { label: 'Web Scrapers' },
        ]}
      />

      <nav className="mb-5 flex flex-wrap items-center gap-3" aria-label="Web scraper navigation">
        <div
          className="inline-flex rounded-xl border border-rule bg-surface p-1"
          role="tablist"
          aria-label="Web scraper views"
        >
          <button
            type="button"
            role="tab"
            aria-selected={view === 'workspace'}
            className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition ${
              view === 'workspace'
                ? 'bg-raised text-signal shadow-sm'
                : 'text-muted hover:text-paper'
            }`}
            onClick={() => setView('workspace')}
          >
            <CircleStackIcon className="h-4 w-4" />
            New request
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={view === 'inventory'}
            className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition ${
              view === 'inventory'
                ? 'bg-raised text-signal shadow-sm'
                : 'text-muted hover:text-paper'
            }`}
            onClick={() => setView('inventory')}
          >
            <WrenchScrewdriverIcon className="h-4 w-4" />
            Scraper inventory
          </button>
        </div>
        <Link
          to="/listings-tool/scraper_requests"
          className="nx-btn-secondary"
        >
          <ClockIcon className="h-4 w-4" />
          Request history
        </Link>
      </nav>

      {view === 'workspace' ? <Workspace /> : <BrandScrapersTable />}
    </AppShell>
  )
}

export default WebScrapers
